import styled from '@emotion/styled';

export const InputContainer = styled.div`
	${(props) => props.viewmode && `overflow: auto;`};
	> label {
		display: flex;
	}
`;

export const InputWrapper = styled.div`
	position: relative;
	cursor: pointer;
	display: flex;
	> span {
		padding: var(--inputPadding) 3.5rem;
		display: flex;
		align-items: center;
		background-color: var(--input-bg-color);
		font-size: var(--paragraph3-font-size);
		width: 100%;
		height: 100%;
		border: 1px solid var(--border-color);
		border-radius: var(--small-border-radius);
		outline: none;

		:hover {
			background-color: var(--table-selected-color);
		}
		:disabled {
			background-color: var(--input-disabled-bg-color);
			color: var(--content-4);
			-webkit-text-fill-color: var(--content-4);
			opacity: 1;
		}
		&.error {
			border: 1px solid var(--red) !important;
			background-color: var(--red-10);
		}
	}

	.leftIconContainer {
		position: absolute;
		top: 0;
		left: 0;
		width: 4rem;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		body[dir='rtl'] & {
			left: unset;
			right: 0;
		}
	}

	.rightIconContainer {
		position: absolute;
		top: 0;
		right: 0;
		width: 4rem;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		body[dir='rtl'] & {
			right: unset;
			left: 0;
		}
	}
`;

export const TimeContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
`;

export const Content = styled.div`
	display: grid;
	justify-items: center;
	width: min-content;
	background-color: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
	box-shadow: var(--container-box-shadow);
`;
